import { Stack } from '@chakra-ui/react';
import { Icon, Typography } from '@shinetools/sunshine-universal';

interface ContainedOptionRowProps {
  label: string;
}

export const ContainedOptionRow = ({ label }: ContainedOptionRowProps) => (
  <Stack alignItems="center" direction="row" gap="space-8">
    <Icon color="$text-primary" icon="tick" />

    <Typography.Text>{label}</Typography.Text>
  </Stack>
);
